<template>
  <div class="container">
    <!-- <div class="daily_tab">
      <img @click="handleBack" style="width: 0.32rem; height: 0.59rem" src="../assets/back.png" />
      <div>日报提交</div>
    </div> -->
    <van-nav-bar title="日报提交" @click-left="handleBack">
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333" />
      </template>
    </van-nav-bar>
    <div class="company_selection" @click="selectCompanyHandler">
      <span>{{ companyName }}</span>
      <i class="iconfont icon-xiangxiajiantou company-arrow"></i>
    </div>
    <div class="report_search">
      <div
        style="display:flex;
          align-items: center;
          border:1px solid;
          height: 26px;
          border-color:#dddddd;
          border-radius:4px;
          padding: 4px;"
        @click="showSelectDate"
      >
        <div>{{ currentDate }}</div>
        <i class="iconfont icon-xiangxiajiantou"></i>
      </div>
      <div class="end_date">数据截止时间：{{ currentDateStr }}</div>
    </div>
    <div class="daily_header">
      <div>名称</div>
      <div>
        <span>已提交</span>
        <img v-if="activeTab != 1 && activeTab != 2" @click="handelSort(1,'asc','submittedNum')" src="@/assets/no_sort.png" />
        <img v-if="activeTab === 1" @click="handelSort(2,'desc','submittedNum')" src="@/assets/up_sort.png" />
        <img v-if="activeTab === 2" @click="handelSort(1,'asc','submittedNum')" src="@/assets/down_sort.png" />
      </div>
      <div>
        <span>补交</span>
        <img v-if="activeTab != 3 && activeTab != 4" @click="handelSort(3,'asc','supplementNum')" src="@/assets/no_sort.png" />
        <img v-if="activeTab === 3" @click="handelSort(4,'desc','supplementNum')" src="@/assets/up_sort.png" />
        <img v-if="activeTab === 4" @click="handelSort(3,'asc','supplementNum')" src="@/assets/down_sort.png" />
      </div>
      <div>
        <span>应提交</span>
        <img v-if="activeTab != 5 && activeTab != 6" @click="handelSort(5,'asc','shouldSubmitNum')" src="@/assets/no_sort.png" />
        <img v-if="activeTab === 5" @click="handelSort(6,'desc','shouldSubmitNum')" src="@/assets/up_sort.png" />
        <img v-if="activeTab === 6" @click="handelSort(5,'asc','shouldSubmitNum')" src="@/assets/down_sort.png" />
      </div>
      <div>
        <span>提交率</span>
        <img v-if="activeTab != 7 && activeTab != 8" @click="handelSort(7,'asc','submitRateDouble')" src="@/assets/no_sort.png" />
        <img v-if="activeTab === 7" @click="handelSort(8,'desc','submitRateDouble')" src="@/assets/up_sort.png" />
        <img v-if="activeTab === 8" @click="handelSort(7,'asc','submitRateDouble')" src="@/assets/down_sort.png" />
      </div>
    </div>
    <div class="daily_item" v-for="(item, index) in data" :key="index">
      <div style="width: 30%;line-height:14px;">{{ item.officeName || item.companyName }}</div>
      <div>{{ item.submittedNum }}</div>
      <div>{{ item.supplementNum }}</div>
      <div>{{ item.shouldSubmitNum }}</div>
      <div>{{ item.submitRate }}</div>
    </div>
    <van-action-sheet v-model="showDatePicker">
      <van-datetime-picker
        v-model="selectedDate"
        :type="type == 'day' ? 'date' : 'year-month'"
        :formatter="formatter"
        title="选择年月"
        @confirm="dateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import { getReportStatisticsSubmitRate, getReportStatisticsSubmitList } from "@/axios/services";
import dayjs from "dayjs";
import VeiBanBridge from "@/utils/bridge";
export default {
  data() {
    return {
      // currentDate: new Date(),
      currentDateStr: this.getDate("yyyy-MM-dd", "yesterday"),
      currentDate: "",
      currentMonth: new Date(),
      currentMonthStr: this.getCurrentMonth(new Date()),
      data: [],
      showDatePicker: false,
      selectedDate: "",
      companyId: "",
      officeId: "",
      selectedCompany: [],
      companyName: "",
      activeTab: '',
      orderType: '',
      orderField: '',
      type: '',
      scopeType: ''
    };
  },
  methods: {
    getDate(format = "yyyy-MM-dd", type) {
      let date = null;
      type = type || "today";
      let now = +Date.now();
      let oneDay = 1000 * 60 * 60 * 24;
      let yesterday = now - oneDay;
      const typeDes = ["yesterday", "today"];
      if (typeDes.includes(type)) {
        date = type === "yesterday" ? new Date(yesterday) : new Date();
      } else {
        date = new Date(type);
      }
      if (date.toString() === "Invalid Date") {
        return;
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    handleBack() {
      this.$router.back();
    },
    selectCompanyHandler() {
      this.$router.push({
        path: "select-data-range",
        query: {
          seletionData: JSON.stringify(this.selectedCompany),
        },
      });
    },
    getCurrentMonth(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1);
    },
    getCurrentDay(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1) + "-" + this.checkTime(date.getDate());
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else {
        return `${val}日`;
      }
    },
    showSelectDate() {
      this.showDatePicker = true;
    },
    dateConfirm() {
      this.showDatePicker = false;
      this.currentDate = this.type === "day" ? dayjs(this.selectedDate).format("YYYY-MM-DD") : dayjs(this.selectedDate).format("YYYY-MM");
      this.getData();
    },
    handelSort(activeTab, sort, param) {
      this.activeTab = activeTab;
      this.orderType = sort;
      this.orderField = param;
      this.getData()
    },
    getData() {
      if (this.type === "day") {
        const params = {
          companyId: this.companyId,
          officeId: this.officeId,
          reportDate: this.currentDate,
          orderType: this.orderType,
          orderField: this.orderField
        };
        if(this.scopeType == 0) {
          params.blocFlag = 'Y'
        }
        getReportStatisticsSubmitList(params).then((res) => {
          if (res.data.code === 0) {
            this.data = res.data.data;
          }
        });
      } else {
        const params = {
          companyId: this.companyId,
          officeId: this.officeId,
          reportMonth: this.currentDate,
          orderType: this.orderType,
          orderField: this.orderField
        };
        if(this.scopeType == 0) {
          params.blocFlag = 'Y'
        }
        getReportStatisticsSubmitList(params).then((res) => {
          if (res.data.code === 0) {
            this.data = res.data.data;
          }
        });
      }
    },
    getYesterday() {
      let day = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      this.selectedDate = day;
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path === "/select-data-range") {
  //     let params = from.params?.selectedData || [];
  //     next((vm) => {
  //       if (params.length) {
  //         vm.selectedCompany = params;
  //         let selected = params[params.length - 1];
  //         vm.companyName = selected.name;
  //         vm.scopeType = selected.type;
  //         vm.companyId = selected.companyId;
  //         vm.officeId = selected.officeId;
  //       }
  //     });
  //   } else {
  //     next();
  //   }
  // },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/select-data-range" || from.path === "/personal-report-board") {
      let params = null;
      let selcetDate = "";
      if (from.path === "/select-data-range") {
        params = from.params?.selectedData || [];
      } else if (from.path === "/personal-report-board") {
        params = to.query?.seletionData ? JSON.parse(to.query?.seletionData) : [];
        selcetDate = to.query?.selectionDate;
      }
      next((vm) => {
        // vm.seletionDateData.selectedDate = selcetDate;
        // vm.selectedDate = new Date(selcetDate);
        if (params.length) {
          vm.selectedCompany = params;
          let selected = params[params.length - 1];
          vm.companyName = selected?.name;
          vm.scopeType = selected?.type;
          if (selected.type == 0 || selected.type == 1) {
            vm.companyId = selected.id;
            vm.officeId = "";
          } else if (selected.type == 2) {
            vm.companyId = "";
            vm.officeId = selected.id;
          }
          // vm.currentPage = 1;
          // vm.dailyList = [];
        }
      });
    } else {
      next();
    }
  },
  async created() {
    const user = (await VeiBanBridge.getUserInfo()) || {};
    // const { companyName, companyId } = user;
    this.companyId = this.companyId ? this.companyId : user?.companyId;
    this.companyName = this.companyName ? this.companyName : user?.companyName;
    this.type = this.$route.query?.type == "天" ? "day" : "month";
    
    // if (this.type === "day") {
    //   // this.currentDate = this.getCurrentDay(new Date());
    //   this.currentDate = this.getDate('yyyy-MM-dd','yesterday')
    // } else {
    //   // this.currentDate = this.getCurrentMonth(new Date());
    //   this.currentDate = this.getDate('yyyy-MM')
    // }
    // this.getYesterday();
    this.orderType = this.$route.query?.orderType;
    this.orderField = this.$route.query?.orderField;
    if(this.orderField === 'submittedNum') {
      this.activeTab = 2
    }
    if(this.orderField === 'submitRateDouble') {
      this.activeTab = 8
    }
    this.selectedDate = new Date(this.$route.query.date);
    this.currentDate = this.$route.query.date;
    this.getData();
  },
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.81rem;
  background: #f9f9f9;
  position: relative;
  /* padding-top: 1.71rem; */
}
.daily_tab {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.daily_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.company_selection {
  text-align: center;
  position: relative;
  height: 44px;
  background-color: #fff;
  line-height: 44px;
}
.report_search {
  height: 1.2rem;
  margin-top: 12px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4rem;
}
.daily_header {
  width: 100%;
  height: 1.5rem;
  margin-top: 10px;
  font-family: Source Han Sans CN;
  font-weight: 700;
  color: #333333;
  font-size: 14px;
  background: #ffffff;
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  border-bottom: 1px solid #ccc;
}
.daily_header div {
  width: 25%;
  margin-left: 10px;
}
.daily_header img {
  width: 16px;
  height: 16px;
}
.daily_item {
  width: 100%;
  height: 1.5rem;
  font-family: Source Han Sans CN;
  color: #333333;
  font-size: 14px;
  background: #ffffff;
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  border-bottom: 1px solid #ccc;
}
.daily_item div {
  width: 25%;
  margin-left: 10px;
  font-family: Source Han Sans CN;
  color: #666666;
  font-size: 14px;
}
.end_date {
  font-family:Source Han Sans CN;
  color:#999999;
  font-size:12px;
  line-height:12px;
}
</style>
